angular.module('callX').controller('CallHistoryCtrl', ['$scope', '$stateParams', 'UserService', '$rootScope', '$state', 'toaster', 'AudioFileService', 'ngAudio', '$sce', '$timeout', function ($scope, $stateParams, UserService, $rootScope, $state, toaster, AudioFileService, ngAudio, $sce, $timeout) {

  var username_agent = $stateParams.username;
  var userId = $stateParams.userId;
  $scope.role;
  $scope.getuserRole;
  $scope.getsalesRole;

  $scope.searchPage = false;
  $scope.tableContentLoading = false; //added

  // $scope.callClosed = false;
  // $scope.answeredCall = false;
  // $scope.offerDetailsFlag = false;
  // $scope.liveNow = false;
  // $scope.incomingCallRinging = false;
  // $scope.totalAnswered = false;
  // $scope.showAlertModel = true; 
  // $scope.showDataModel = false;

  // $scope.onHangupCallStatus = false;
  // $scope.switchStatus = true;
  $scope.callHistoryData;

  // $scope.frwdOfferData={};//added     
  //  $scope.validateCount=0;//added 

  //  $scope.optionsArrCreate=[];
  //  $scope.forwardflag = false;
  //  $scope.rightblock=false;
  //  var timer,timerInter;
  //  $scope.sidecondition=false;
  //  //document.getElementsByClassName("leadDisable").style.disabled=true;
  //  $scope.loading = false;
  //  $scope.showNoOffersMessage = false;


  $scope.setAgentFirsAandLastName = function () {
    $scope.username_firstName = window.localStorage.getItem("first_name")
    $scope.username_lastName = window.localStorage.getItem("last_name")
    $scope.user_name = window.localStorage.getItem("user_name")
    $scope.user_id = window.localStorage.getItem("user_id")
    $scope.role = window.localStorage.getItem("role");

    if ($scope.role === 'AGENT') {
      $scope.role = 'salesagent';
    }
    $scope.email = window.localStorage.getItem("email")
    if ($scope.role == 'useragent') {
      $scope.getuserRole = $scope.role;
      $scope.getAgentStats();
    } else if ($scope.role == 'salesagent') {
      $scope.getsalesRole = $scope.role;
      $scope.getsalesAgentStats();
    }
  }

  $scope.statusData = ["paid", "unpaid"];
  $scope.sourcesArray = [];

  //calendar starts  
  $scope.dpOpened1 = false;

  $scope.open = function ($event) {
    $event.preventDefault();
    $event.stopPropagation();
    $scope.dpOpened1 = !$scope.dpOpened1;
  };

  $scope.dateOptions = {
    formatYear: 'yyyy',
    startingDay: 0,
    class: 'datepicker',
    showWeeks: false
  };

  $scope.format = 'MM/dd/yyyy';

  $scope.$watch('$scope.submitted_date', function (newDate) {
    if (newDate) {
      // console.log(newDate, "get new date")
      $scope.submitted_date = moment($scope.submitted_date).format("MM/dd/yyyy");
    }
  });

  // $scope.today = function() {
  //     $scope.getDate = new Date();
  // };
  // $scope.today();

  $scope.openDatePicker = function ($event) {
    console.log("open date")
    $event.preventDefault();
    $event.stopPropagation();

    $scope.openedFrom = true;
  };

  $scope.dateOptionsDatePicker = {
    formatYear: 'yy',
    startingDay: 0,
    class: 'datepicker',
    showWeeks: false
  };
  //calendar ends

  $scope.playCallRecording = function (url) {
    $scope.showAudioFileLoading = url;
    if ($scope.sound != undefined) {
      $scope.sound.stop();
      $scope.currentAudioPlayingUrl = '';
    }

    if (url) {
      var callUUID = url.split("/").pop().split(".")[0];

      var callbacks = {
        success: function (data) {
          if ($scope.sound != undefined) {
            $scope.sound.stop();
          }
          $scope.currentAudioPlayingUrl = url;
          $scope.sound = ngAudio.load(data.recording_url);
          $scope.sound.play();
          $scope.showAudioFileLoading = '';
        },
        failure: function (data) {
          $scope.currentAudioPlayingUrl = '';
          $scope.showAudioFileLoading = '';
        }
      };

      AudioFileService.getAudioFile(callUUID, callbacks)
    }
  };

  $scope.pauseCallRecording = function () {
    $scope.sound.pause();
  };

  $scope.resumeCallRecording = function () {
    $scope.sound.play();
  };
  $scope.stopCallRecording = function () {
    if ($scope.sound) {
      $scope.sound.stop();
      $scope.currentAudioPlayingUrl = '';
    }
  };
  $scope.$on('$destroy', function () {
    $scope.stopCallRecording();
  });

  $scope.loadingRecording = false;
  $scope.isPlaying = false;
  $scope.audioProgress = 0;
  $scope.currentTime = "0:00";
  $scope.duration = "0:00";
  $scope.downloadUrl = "";
  $scope.currentCall = {};
  $scope.sound = null;

  // Format audio time for display (e.g. 1:23)
  $scope.formatAudioTime = function (seconds) {
    if (isNaN(seconds) || seconds < 0) {
      return "0:00";
    }

    var mins = Math.floor(seconds / 60);
    var secs = Math.floor(seconds % 60);
    return mins + ':' + (secs < 10 ? '0' + secs : secs);
  };

  $scope.copyToClipboard = function (text, $event) {
    if ($event) $event.stopPropagation();

    // Create temporary input element
    const tempInput = document.createElement('input');
    document.body.appendChild(tempInput);
    tempInput.value = text;
    tempInput.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        toaster.pop('success', 'Success', 'Copied to clipboard!');
      } else {
        throw new Error('Copy command was unsuccessful');
      }
    } catch (err) {
      toaster.pop('error', 'Error', 'Failed to copy to clipboard');
    }

    // Clean up
    document.body.removeChild(tempInput);
  };

  // Toggle play/pause state
  $scope.playPause = function () {
    if (!$scope.audio) return;

    if ($scope.isPlaying) {
      $scope.audio.pause();
    } else {
      $scope.audio.play().catch(function (error) {
        toaster.pop('error', 'Playback Error', 'Failed to play audio');
      });
    }
    $scope.isPlaying = !$scope.isPlaying;
  };

  // Handle seeking on the progress bar
  $scope.seek = function (event) {
    if (!$scope.audio || !$scope.audio.duration || isNaN($scope.audio.duration)) return;

    var progressBar = event.currentTarget;
    var rect = progressBar.getBoundingClientRect();
    var clickPosition = event.clientX - rect.left;
    var progressBarWidth = rect.width;
    var seekPosition = (clickPosition / progressBarWidth) * 100;

    // Ensure seek position is within bounds
    seekPosition = Math.max(0, Math.min(100, seekPosition));

    var newTime = (seekPosition / 100) * $scope.audio.duration;

    // Only set currentTime if it's a valid number
    if (!isNaN(newTime) && isFinite(newTime)) {
      $scope.audio.currentTime = newTime;
      $scope.audioProgress = seekPosition;
      $scope.currentTime = newTime;
      $scope.$apply();
    }
  };

  // Make slider draggable
  $scope.startDragging = function (event) {
    if (!$scope.audio) return;

    $scope.isDragging = true;
    $scope.wasPlayingBeforeDrag = $scope.isPlaying;
    if ($scope.isPlaying) {
      $scope.audio.pause();
    }

    angular.element(document).on('mousemove', $scope.handleDrag);
    angular.element(document).on('mouseup', $scope.stopDragging);
    angular.element(document).on('mouseleave', $scope.stopDragging);
  };

  $scope.handleDrag = function (event) {
    if (!$scope.isDragging || !$scope.audio || !$scope.audio.duration || isNaN($scope.audio.duration)) return;

    var progressBar = document.querySelector('.progress');
    if (!progressBar) return;

    var rect = progressBar.getBoundingClientRect();
    var seekPosition = ((event.clientX - rect.left) / rect.width) * 100;

    // Ensure seek position is within bounds
    seekPosition = Math.max(0, Math.min(100, seekPosition));

    var newTime = (seekPosition / 100) * $scope.audio.duration;

    // Only update if we have valid values
    if (!isNaN(newTime) && isFinite(newTime)) {
      $scope.audioProgress = seekPosition;
      $scope.currentTime = newTime;
      $scope.$apply();
    }
  };

  $scope.stopDragging = function () {
    if (!$scope.isDragging || !$scope.audio || !$scope.audio.duration || isNaN($scope.audio.duration)) {
      $scope.isDragging = false;
      return;
    }

    $scope.isDragging = false;
    var newTime = ($scope.audioProgress / 100) * $scope.audio.duration;

    // Only set currentTime if it's a valid number
    if (!isNaN(newTime) && isFinite(newTime)) {
      $scope.audio.currentTime = newTime;

      // If it was playing before dragging, continue playing
      if ($scope.wasPlayingBeforeDrag) {
        $scope.audio.play().catch(function (error) {
          // console.error('Failed to resume playback after dragging:', error);
        });
        $scope.wasPlayingBeforeDrag = false;
      }
    }

    angular.element(document).off('mousemove', $scope.handleDrag);
    angular.element(document).off('mouseup', $scope.stopDragging);
    angular.element(document).off('mouseleave', $scope.stopDragging);
  };

  // Function to stop audio and close modal
  $scope.stopAudioAndClose = function () {
    if ($scope.audio) {
      $scope.audio.pause();
      $scope.audio.currentTime = 0;
      $scope.isPlaying = false;
      $scope.audioProgress = 0;
      $scope.currentTime = 0;
    }
  };

  // Clean up audio when controller is destroyed
  $scope.$on('$destroy', function () {
    $scope.stopAudioAndClose();
  });


  $scope.limitTextLength = function (text) {
    return text.slice(0, 4) + '..'
  }

  $scope.setAgentFirsAandLastName();

  $scope.callScreenPage = function () {
    // console.log("home screen")
    $rootScope.currentPage = 'home';
    $state.go('app.sales-agent', { username: $scope.user_name, userId: $scope.user_id });
  }

  $scope.rootDispositions = ["Application Submitted", "Refund", "Pending", "No Sale", "Caller Hang Up"];
  $scope.dispositions = ["Pending", "Application Submitted", "No One On Phone", "Caller Hung Up", "Coverage",
    "Customer Service", "Rate Too High", "Changed Mind", "Not Qualified", "Language Barrier", "Insured",
    "Insurance Type", "Benefits", "Does Not Qualify", "Call Dropped", "Technical Issue"
  ];

  //  root disposition multiple selection start 
  // $scope.checkedStages = {};
  // $scope.selectedStages = [];
  //     $scope.updateSelectedStages = function() {
  //         $scope.Stage = [];
  //         console.log($scope.checkedStages , "checked stage values")
  //         for (var stage in $scope.checkedStages) {
  //             if ($scope.checkedStages[stage]) {
  //                 $scope.selectedStages.push(stage);
  //             }
  //         }
  //         console.log($scope.selectedStages, "selected stages")
  //     };

  // disposition multiple selection start 
  // $scope.checkedDispositions = {};
  // $scope.selectedDispositions = [];
  //     $scope.updateSelectedDispositions = function() {
  //         $scope.Disposition = [];
  //         console.log($scope.checkedStages , "checked disposition values")
  //         for (var disposition in $scope.checkedDispositions) {
  //             if ($scope.checkedDispositions[disposition]) {
  //                 $scope.selectedDispositions.push(disposition);
  //             }
  //         }
  //         console.log($scope.selectedDispositions, "selected dispositions")
  //     };


  // $scope.currentPage = 'callhistory'; 

  $scope.currentPage = 0;
  $scope.itemsPerPage = 10;
  $scope.maxSize = 5;

  $scope.agentCallHistory = function () {
    $scope.tableContentLoading = true;
    $rootScope.currentPage = 'callhistory';
    $state.go('app.sales-agent.callhistory', { username: $scope.user_name, userId: $scope.user_id });

    var callbacks = {
      success: function (data) {
        // console.log(data, "lead history -----")
        $scope.callHistoryData = data.data.call_history_dto;
        $scope.sourcesArray = data.data.publisher_name;
        $scope.totalPages = data.data.total_pages;
        $scope.totalItems = data.data.total_records;
        $scope.tableContentLoading = false;
      },
      failure: function (data) {
        $scope.tableContentLoading = false;
      }
    };
    UserService.getCallHistory(userId, $scope.role, $scope.currentPage, $scope.itemsPerPage, callbacks); //added
  }
  $scope.agentCallHistory();

  $scope.pageChanged = function () {
    // console.log($scope.currentPage,$scope.itemsPerPage, "inisde page change ")
    $scope.tableContentLoading = true;
    var callbacks = {
      success: function (data) {
        // console.log(data, "pagination lead history -----")
        $scope.callHistoryData = data.data.call_history_dto;
        $scope.sourcesArray = data.data.publisher_name;
        $scope.totalPages = data.data.total_pages;
        $scope.totalItems = data.data.total_records;
        $scope.tableContentLoading = false;
      },
      failure: function (data) {
        $scope.tableContentLoading = false;
      }
    };
    UserService.getCallHistory(userId, $scope.role, $scope.currentPage - 1, $scope.itemsPerPage, callbacks);
  }

  $scope.formatDateToYYYYMMDD = function (val) {
    var date = new Date(val);
    if (typeof val === 'string' && val.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      var parts = val.split('/');
      var day = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10) - 1; // month is 0-based in JS Date
      var year = parseInt(parts[2], 10);

      // Create a Date object with the parsed values
      date = new Date(year, month, day);
    }
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1);
    var day = String(date.getDate());
    month = month.length === 1 ? '0' + month : month;
    day = day.length === 1 ? '0' + day : day;
    return year + '-' + month + '-' + day + " " + '00:00:00';
    // return day + '/' + month + '/' + year + " " + '00:00:00';
  }

  // filter Records
  $scope.filterCallHistoryRecords = function (currentSearchNumber) {
    var filtersHistoryObject = {
      filters: []
    };
    $scope.searchPage = true;
    $scope.tableContentLoadingSearch = true;
    if ($scope.userNameOrPhone) {
      var input = $scope.userNameOrPhone.trim();
      // console.log(input, "get")
      // Check if the input is a number (phone number)
      if (!isNaN(input)) {
        // console.log("number")
        filtersHistoryObject.filters.push({
          key: "fromNumber",
          operation: "contains",
          value: input
        });
      } else {
        // console.log("name")
        filtersHistoryObject.filters.push({
          key: "fromCallerName",
          operation: "contains",
          value: input
        });
      }
    }

    // Set ref_from property to $scope.getDate value
    // if ($scope.getDate) {
    //     filtersObject.ref_from = $scope.getDate;
    // }
    if ($scope.submitted_date) {
      var getCreatedAt = {
        "key": "callHistoryCreatedAt",
        "operation": "=",
        "value": $scope.formatDateToYYYYMMDD($scope.submitted_date)
      };
      filtersHistoryObject.filters.push(getCreatedAt);
    }


    // pass salesagentId 
    if ($scope.user_id) {
      var salesUser_Id = {
        "key": "salesAgentId",
        "operation": "=",
        "value": $scope.user_id
      };
      filtersHistoryObject.filters.push(salesUser_Id);
    }

    // Check if rootDisposition has a value selected
    if ($scope.stage) {
      var stageFilter = {
        key: "salesAgentRootDisposition",
        operation: "equals",
        value: $scope.stage
      };
      // Push the filter object into the filters array
      filtersHistoryObject.filters.push(stageFilter);
    }

    // Check if disposition has a value selected
    if ($scope.disposition) {
      var dispositionFilter = {
        key: "salesAgentDisposition",
        operation: "equals",
        value: $scope.disposition
      };
      filtersHistoryObject.filters.push(dispositionFilter);
    }

    // console.log(filtersHistoryObject, "get filter object")

    filtersHistoryObject.daypart = -1;

    $scope.itemsSearchPerPage = 10;
    $scope.maxSearchSize = 3;

    if (currentSearchNumber) {
      $scope.currentSearchPage = currentSearchNumber;
    } else {
      $scope.currentSearchPage = 0;
    }

    if ($scope.currentSearchPage > 0) {
      filtersHistoryObject.page = $scope.currentSearchPage - 1;
    } else {
      filtersHistoryObject.page = $scope.currentSearchPage;
    }

    filtersHistoryObject.size = $scope.itemsSearchPerPage;

    var callbacks = {
      success: function (data) {
        // console.log("log filter search data history---------", data, data.data.call_history_dtos)
        $scope.callHistoryData = data.data.call_history_dtos;
        $scope.totalSearchPages = data.data.total_pages;
        $scope.totalSearchItems = data.data.total_records;
        // Ensure each entry has a score key
        if (Array.isArray($scope.callHistoryData)) {
          $scope.callHistoryData.forEach(function (entry) {
            if (typeof entry.callscore === 'undefined') {
              entry.callscore = null;
            }
          });
        }

        $scope.tableContentLoadingSearch = false;
      },
      failure: function (data) {
        // $scope.tableContentLoading = false;
        $scope.tableContentLoadingSearch = false;
      }
    };
    UserService.callHistoryPageReportsData(filtersHistoryObject, callbacks);
  };

  $scope.pageChangedSearch = function () {
    $scope.filterCallHistoryRecords($scope.currentSearchPage)
  }

  // reset filters 
  $scope.exportCallHistoryCSV = function () {
    var filters = {
      userNameOrPhone: $scope.userNameOrPhone,
      submitted_date: $scope.submitted_date ? moment($scope.submitted_date).format('YYYY-MM-DD') : '',
      stage: $scope.stage,
      disposition: $scope.disposition
    };
    AudioFileService.exportCallsHistoryCSV(filters);
  };

  $scope.resetCallHistoryFilters = function () {
    $scope.userNameOrPhone = '';
    $scope.submitted_date = '';
    $scope.stage = '';
    $scope.disposition = '';
    $scope.searchPage = false;
    $scope.agentCallHistory();
    // $scope.pageChanged();
  };

  $scope.isName = function (name) {
    if (!name) return false;
    name = name.replace(/null/g, '');
    return /[a-zA-Z]/.test(name);
    // return name && /[a-zA-Z]/.test(name);
  }

  $scope.formatPhoneNumber = function (phoneNumber) {
    phoneNumber = phoneNumber.replace(/^1|^91/, '');
    var formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    return formattedPhoneNumber;
  };

  $scope.formatTime = function (timeString) {
  if (!timeString) return '-';

  // Normalize input: replace 'T' with space and remove '.0' or 'Z'
  timeString = timeString.replace('T', ' ').replace(/(\.0+|Z)$/, '');

  var date = new Date(timeString);

  if (isNaN(date.getTime())) return '-';

  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var day = date.getDate().toString().padStart(2, '0');
  var year = date.getFullYear();

  var hours = date.getHours();
  var minutes = date.getMinutes().toString().padStart(2, '0');

  var suffix = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return month + '/' + day + '/' + year + ', ' + hours + ':' + minutes + ' ' + suffix;
};


  $scope.formatDuration = function (timeString) {
    var formattedTime;
    if (timeString.toString()) {
      var hours = Math.floor(timeString / 60);
      var minutes = timeString % 60;

      return hours + ":" + (minutes < 10 ? "0" : "") + minutes;
    } else {
      formattedTime = ''
    }
    return formattedTime;
  };

  $scope.historyToContactDetailsPage = function (contactName, PhoneNumber) {
    $rootScope.currentPage = 'contactpage'
    $state.go('app.sales-agent.details', { contactName: contactName, phoneNumber: PhoneNumber });
  }

  // --- Expandable Row and Tab Logic for Call History ---
  $scope.getNumericScore = function(scoreValue) {
    if (scoreValue === null || scoreValue === undefined) {
      return 0;
    }
  
    if (typeof scoreValue === 'string') {
      var numericPart = scoreValue.split('/')[0];
      return parseInt(numericPart, 10) || 0;
    }
  
    return scoreValue;
  };

   $scope.getScoreColor = function(score) {
      if (score < 60) {
        return {
          start: '#DB7278',
          end: '#D36E73'
        };
      } else if (score >= 60 && score < 80) {
        return {
          start: '#DBC372',
          end: '#D3BB6E'
        };
      }
      return {
        start: '#71DB8B',
        end: '#7EDB72'
      };
    };

    $scope.getScoreStyle = function(score) {
      if (!score || isNaN(score)) {
        return {
          background: '#e0e0e0',
          color: '#000'
        };
      }

      var color = $scope.getScoreColor(score).start;
      var degree = (score / 100) * 360;

      return {
        background: 'conic-gradient(' + color + ' 0deg ' + degree + 'deg, #e0e0e0 ' + degree + 'deg 360deg)',
        color: '#000'
      };
    };

    // Helper function to extract numeric score from "X/100" format
    $scope.getCallScoreValue = function(scoreStr) {
      if (!scoreStr) return 0;
      if (typeof scoreStr === 'number') return scoreStr;
      var match = scoreStr.toString().match(/(\d+)/);
      return match ? parseInt(match[1], 10) : 0;
    };

    $scope.getCallScoreTextColor = function(scoreStr) {
      if (!scoreStr || scoreStr === 'N/A') {
        return '#6b7280'; 
      }
      var score = $scope.getCallScoreValue(scoreStr); 
      return $scope.getScoreColor(score).start; 
    };

  // Toggle expandable row for a lead
  $scope.toggleExpand = function (lead) {
    console.log('lead --->', lead)
    var wasExpanded = lead.expanded;

    // Collapse all other rows
    $scope.callHistoryData.forEach(function (c) {
      if (c !== lead) {
        c.expanded = false;
      }
    });

    // Toggle the clicked row
    lead.expanded = !wasExpanded;

    if (lead.expanded) {
      // Set default tab to transcription
      lead.activeTab = 'transcription';

      // Check if we already have transcription data
      if (lead.transcription && lead.transcription.status === 'IN_PROGRESS') {
        // Show in-progress state for transcription
        lead.transcriptionLoading = false;
        lead.transcriptionLoaded = true;

        // Don't make summary API lead when transcription is in progress
        lead.aiSummaryError = true;
        lead.aiSummaryLoaded = true;
        lead.aiSummaryData = null;
      }
      // Only make transcription API lead if not already in progress
      else if (lead.connected_duration >= 1) {
        // Request transcription first
        lead.transcriptionLoading = true;
        lead.transcriptionError = false;
        $scope.requestTranscription(lead);

        // Only make summary API lead if lead duration is sufficient
        if (lead.connected_duration >= 1) {
          lead.aiSummaryLoading = true;
          lead.aiSummaryError = false;
          lead.aiSummaryData = null;
          $scope.loadAISummary(lead, function () {
            lead.aiSummaryLoading = false;
          });
        } else {
          // Always set the score from table data if available, regardless of lead duration
          if (lead.callscore !== undefined && lead.callscore !== null) {
            lead.callscore = $scope.getNumericScore(lead.callscore);
          }
          // Set error state to show the appropriate message
          lead.aiSummaryError = true;
          lead.aiSummaryLoaded = true;
        }
      } else {
        // Call is too short for transcription
        lead.transcriptionError = true;
        lead.transcriptionLoaded = true;
        lead.aiSummaryError = true;
        lead.aiSummaryLoaded = true;
      }
    }
  };

  // Set active tab and load content if needed
  $scope.setActiveTab = function (lead, tab) {
    console.log('lead', lead)
    lead.activeTab = tab;
    $scope.openTab(lead, tab);
  };

  // Tab content loader
  $scope.openTab = function (lead, tab) {
    if (tab === 'transcription') {
      if (lead.connected_duration >= 1) {
        $scope.requestTranscription(lead);
      } else {
        lead.transcriptionError = true;
        lead.transcriptionLoaded = true;
      }
    } else if (tab === 'summary') {
      lead.aiSummaryLoading = true;
      lead.aiSummaryError = false;
      if (lead.connected_duration >= 1) {
        lead.aiSummaryData = null;
        $scope.loadAISummary(lead, function () {
          lead.aiSummaryLoading = false;
        });
      } else {
        lead.aiSummaryError = true;
        lead.aiSummaryLoaded = true;
        lead.aiSummaryLoading = false;
      }
    }
  };

  // Request transcription data (stub: replace with real API lead if needed)
  $scope.requestTranscription = function (lead) {
    // Show loading indicator in transcription tab
    // console.log("lead requested transcription", lead)
    lead.transcription = [];
    lead.transcriptionLoading = true;

    var callbacks = {
      success: function (data) {
        try {
          if (Array.isArray(data) && data.length > 0) {
            var transcription = data[0];
            var status = transcription.status;
            // var status = 'IN_PROGRESS';
            var transcriptionText = transcription.transcriptionText;

            if (status === 'COMPLETED') {
              // Set transcription data or mark as not available
              lead.transcription = transcriptionText ? transcription : { notavailable: true };

              if (!lead.transcription.notavailable) {
                // Normalize transcriptionText to array if needed
                if (!Array.isArray(lead.transcription.transcriptionText)) {
                  lead.transcription.transcriptionText = [{
                    text: lead.transcription.transcriptionText || '',
                    speaker: '',
                    timestamp: ''
                  }];
                }
              }
            } else if (status === 'IN_PROGRESS') {
              lead.transcription = { status: 'IN_PROGRESS' };
              lead.aiSummaryError = true;
              lead.aiSummaryLoaded = true;
              lead.aiSummaryLoading = false;

              // Check again after 1 seconds
              setTimeout(function () {
                $scope.requestTranscription(lead);
              }, 30000);
            } else {
              // Handle other statuses or errors
              lead.transcriptionError = true;
              // lead.transcription = { error: true };
            }

            lead.transcriptionLoaded = true;
            lead.transcriptionLoading = false;

            // Update the UI
            if (!$scope.$$phase) {
              $scope.$apply();
            }
          } else {
            // lead.transcription = { error: true };
            lead.transcriptionLoading = false;
            lead.transcriptionLoaded = false;
            lead.transcriptionError = true;
          }
        } catch (e) {
          lead.transcriptionError = true;
        } finally {
          lead.transcriptionLoading = false;
        }

        // Apply changes
        if (!$scope.$$phase) {
          $scope.$apply();
        }
      },
      failure: function (data, status) {
        lead.transcriptionLoading = false;
        lead.transcriptionError = true;

        // Apply changes
        if (!$scope.$$phase) {
          $scope.$apply();
        }
      }
    };

    // Make API lead with just this lead's UUID in an array
    AudioFileService.requestTranscription([lead.call_uuid], callbacks);
  };


  // Load AI summary (stub: replace with real API lead if needed)
  $scope.loadAISummary = function (lead, onComplete) {
    lead.aiSummaryData = [];
    // If transcription is in progress, don't fetch summary
    if (lead.transcription && lead.transcription.status === 'IN_PROGRESS') {
      lead.aiSummaryError = true;
      lead.aiSummaryLoaded = true;
      lead.aiSummaryLoading = false;
      if (typeof onComplete === 'function') {
        onComplete();
      }
      return;
    }

    // If lead is too short
    if (lead.connected_duration < 1) {
      lead.aiSummaryError = true;
      lead.aiSummaryLoaded = true;
      lead.aiSummaryData = null;
      if (typeof onComplete === 'function') {
        onComplete();
      }
      return;
    }

    lead.aiSummaryLoading = true;
    lead.aiSummaryError = false;
    lead.aiSummaryLoaded = false;
    // lead.aiSummaryData = null;


    var aiSummaryCallbacks = {
      success: function (response) {
        try {
          if (response && response.payload) {
            lead.aiSummaryData = response.payload;
            console.log("lead aisummarydata", lead.aiSummaryData )
            lead.aiSummaryError = false;

            if (response.payload.callScore) {
              lead.callscore = $scope.getNumericScore(response.payload.callScore);
            }
          } else {
            lead.aiSummaryError = true;
          }
        } catch (e) {
          lead.aiSummaryError = true;
        } finally {
          lead.aiSummaryLoading = false;
          lead.aiSummaryLoaded = true;
          if (typeof onComplete === 'function') {
            onComplete();
          }
          if (!$scope.$$phase) {
            $scope.$apply();
          }
        }
      },
      failure: function () {
        lead.aiSummaryError = true;
        lead.aiSummaryLoading = false;
        lead.aiSummaryLoaded = true;
        if (typeof onComplete === 'function') {
          onComplete();
        }
        if (!$scope.$$phase) {
          $scope.$apply();
        }
      }
    };

    AudioFileService.getCallAISummary(lead.call_uuid, aiSummaryCallbacks);
  };

  // Markdown rendering for transcription/summary
  $scope.renderMarkdown = function (text) {
    if (!text) return '';

    // Check if markdown-it is available
    if (typeof window.markdownit !== 'function') {
      console.error('markdown-it library is not loaded');
      return $sce.trustAsHtml(text);
    }

    try {
      // Use markdown-it library to render markdown
      const md = window.markdownit({
        html: true,
        linkify: true,
        typographer: true
      });

      // Render markdown and return as trusted HTML
      const rendered = md.render(text);
      return $sce.trustAsHtml(rendered);
    } catch (e) {
      return $sce.trustAsHtml(text); // Return original text if markdown rendering fails
    }
  };

  // Markdown rendering for transcription/summary
  $scope.renderMarkdown = function (text) {
    if (!text) return '';
    if (typeof window.markdownit !== 'function') {
      return text;
    }
    try {
      var md = window.markdownit({ html: true, linkify: true, typographer: true });
      return md.render(text);
    } catch (e) {
      return text;
    }
  };


  $scope.safeApply = function (fn) {
    var phase = this.$root.$$phase;
    if (phase === '$apply' || phase === '$digest') {
      if (fn && (typeof (fn) === 'function')) {
        fn();
      }
    } else {
      this.$apply(fn);
    }
  };
  // Convert markdown-like text to HTML and mark as trusted
  $scope.getTrustedHtml = function (rawMessage) {
    return $sce.trustAsHtml($scope.formatAISummaryMessage(rawMessage));
  };

  $scope.formatAISummaryMessage = function (message) {
    if (!message) return '';

    var formatted = message;

    // Completely remove CALL SCORE line
    formatted = formatted.replace(/CALL SCORE:.*?\n+/g, '');

    // Section Headings (no icons)
    formatted = formatted.replace(/Detailed Scoring:/g, '<h4>Detailed Scoring</h4>');
    formatted = formatted.replace(/Key Strengths:/g, '<hr><h4>Key Strengths</h4>');
    formatted = formatted.replace(/Areas for Improvement:/g, '<h4>Areas for Improvement</h4>');
    formatted = formatted.replace(/Overall Assessment:/g, '<hr><h4>Overall Assessment</h4>');
    formatted = formatted.replace(/Coaching Suggestions:/g, '<h4>Coaching Suggestions</h4>');
    formatted = formatted.replace(/Immediate Action Items:/g, '<h5>Immediate Action Items</h5>');
    formatted = formatted.replace(/Role-Play Scenarios for Practice:/g, '<h5>Role-Play Scenarios for Practice</h5>');
    formatted = formatted.replace(/Script Improvements:/g, '<h5>Script Improvements</h5>');
    formatted = formatted.replace(/Training Recommendations:/g, '<h5>Training Recommendations</h5>');

    // Scored sections: 1. Title: 10/10 - Description
    formatted = formatted.replace(
      /(\d+)\.\s(.*?):\s(\d+\/\d+)\s-\s(.+)/g,
      '<div style="margin-bottom: 10px;"><strong>$2: $3</strong><br><span>$4</span></div>'
    );

    // Bullets to list items
    formatted = formatted.replace(/- (.*)/g, '<li>$1</li>');

    // Wrap single list items with <ul>
    formatted = formatted.replace(/(<li>.*?<\/li>)/g, '<ul>$1</ul>');

    // Convert remaining newlines to <br>
    formatted = formatted.replace(/\n+/g, '<br>');

    return formatted;
  };

  // Play recording with actual audio playback
  $scope.playRecording = function (lead) {
    // Stop existing audio if any
    if ($scope.audio) {
      $scope.audio.pause();
      $scope.audio = null;
    }

    $scope.currentCall = lead;
    $scope.loadingRecording = true;
    $scope.isPlaying = false;
    $scope.audioProgress = 0;
    $scope.currentTime = 0;
    $scope.duration = 0;
    $scope.downloadUrl = "";

    // Fetch latest lead details including recording_url
    AudioFileService.getCall(lead.call_uuid, {
      success: function (data) {
        const recordingUrl = data && data.url;
        if (!recordingUrl) {
          $scope.loadingRecording = false;
          $scope.safeApply();
          return;
        }

        $scope.downloadUrl = recordingUrl;

        // Create audio and setup listeners
        $scope.audio = new Audio(recordingUrl);

        $scope.audio.addEventListener('loadedmetadata', function () {
          $scope.duration = $scope.audio.duration;
          $scope.loadingRecording = false;
          $scope.safeApply();
          $scope.playPause(); // auto play
        });

        $scope.audio.addEventListener('timeupdate', function () {
          $scope.currentTime = $scope.audio.currentTime;
          $scope.audioProgress = ($scope.audio.currentTime / $scope.audio.duration) * 100 || 0;
          $scope.safeApply();
        });

        $scope.audio.addEventListener('ended', function () {
          $scope.isPlaying = false;
          $scope.audioProgress = 0;
          $scope.currentTime = 0;
          $scope.safeApply();
        });

        $scope.audio.addEventListener('error', function () {
          toaster.pop('error', 'Playback Error', 'Failed to play audio.');
          $scope.loadingRecording = false;
          $scope.safeApply();
        });

        $timeout(function () {
          $('#callRecordingModal').modal('show');
        });

      },
      failure: function (err) {
        $scope.loadingRecording = false;
        $scope.safeApply();
      }
    });
  };

  // Clean up when modal is closed
  $scope.$on('modal.hidden', function () {
    if ($scope.audio) {
      $scope.audio.pause();
      $scope.audio = null;
    }
    $scope.isPlaying = false;
    $scope.audioProgress = 0;
    $scope.currentTime = 0;
    $scope.loadingRecording = false;
  });

  // --- END Expandable Row and Tab Logic ---
  $scope.exportCallHistoryCSV = function () {
    var filters = {
      userNameOrPhone: $scope.userNameOrPhone,
      submitted_date: $scope.submitted_date ? moment($scope.submitted_date).format('YYYY-MM-DD') : '',
      stage: $scope.stage,
      disposition: $scope.disposition
    };
    AudioFileService.exportCallsHistoryCSV(filters);
  };

  $scope.resetCallHistoryFilters = function () {
    $scope.userNameOrPhone = '';
    $scope.submitted_date = '';
    $scope.stage = '';
    $scope.disposition = '';
    $scope.filterCallHistoryRecords();
  };

}]);